import {type LngLat, useLocationsRequest} from '@yandex-delivery/blocks'
import {type Optional} from '@yandex-delivery/types'
import {isPoint} from '@yandex-taxi/react-integration-api'
import {useMemo} from 'react'

import {DeliveryType} from 'src/shared/types'

import {useVerticalType} from '../../hooks/use-vertical-type'
import {useDeliveryType} from './hooks/use-delivery-type'
import {useOrderPointsCoordinates} from './hooks/use-order-points-coordinates'
import {useSourcePointCoordinates} from './hooks/use-source-point-coordinates'
import type {Props} from './types'
import {useFetchAddressByLocation} from './use-fetch-address-by-location'

export function useFormMap({location}: Pick<Props, 'location'>) {
  const {rawVertical: verticalType} = useVerticalType()
  const deliveryType = useDeliveryType()
  const sourcePointCoordinates = useSourcePointCoordinates() as Optional<LngLat>
  const orderPointsCoordinates = useOrderPointsCoordinates() as Optional<LngLat>[]
  const {fetchTaxiSuggestHandler, isPending} = useFetchAddressByLocation(location)
  const mapLocationResult = useLocationsRequest({
    centerCoords: location,
    zoom: 16,
    duration: 100,
  })

  const isDragPointAllowed = deliveryType !== DeliveryType.NDD && verticalType !== DeliveryType.NDD
  const isRouteVisible = deliveryType !== DeliveryType.NDD && verticalType !== DeliveryType.NDD

  const routeHash = JSON.stringify(orderPointsCoordinates)

  const routePointCoordinates = useMemo(() => {
    return orderPointsCoordinates.filter(isPoint)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeHash])

  return {
    isPending,
    isDragPointAllowed,
    isRouteVisible,
    orderPointsCoordinates,
    routePointCoordinates,
    mapLocationResult,
    fetchTaxiSuggestHandler,
    sourcePointCoordinates,
  } as const
}
